import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";
import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const homepageRoutes = [
  {
    page: MainPage,
    path: pathRoutes.homepage,
    screenCode: SCREEN.IP_001,
  },
  {
    page: MainPage,
    path: "",
    screenCode: SCREEN.IP_001,
  },
];
